import { ComponentGraphGroup, ComponentGraphNode } from '@ardoq/graph';
import type { BlocksViewNode } from '../types';
import { GraphItemsToRelationshipsNodesReducerState } from 'tabview/relationshipDiagrams/types';

export type BlocksViewReducerState =
  GraphItemsToRelationshipsNodesReducerState<BlocksViewNode>;

export const reduceNodes = (
  state: BlocksViewReducerState,
  graphNode: ComponentGraphNode | ComponentGraphGroup
): BlocksViewReducerState => {
  const children = state.groupChildren.get(graphNode as ComponentGraphGroup);

  const node = state.createNode({
    graphNode,
    parent: state.parent,
    children,
    contextComponentId: state.contextComponentId,
  });

  if (children) {
    children.reduce(reduceNodes, {
      ...state,
      parent: node,
    });
    node.children = children.map(childGraphNode =>
      state.map.get(childGraphNode.id)!
    );
  }
  if (state.parent) {
    state.parent.children ??= [];
    state.parent.children.push(node);
  }

  state.map.set(graphNode.id, node);
  return state;
};
